import { InputGroup, type Props as InputGroupProps } from './InputGroup';
import { ForwardedRef, forwardRef } from 'react';
import { TextField, type TextFieldProps, InputProps } from 'react-aria-components';

import { Field, type FieldProps } from '../field';
import styles from './Input.module.css';

export type Props = Pick<
  TextFieldProps,
  | 'value'
  | 'defaultValue'
  | 'onChange'
  | 'onBlur'
  | 'autoComplete'
  | 'autoCorrect'
  | 'autoFocus'
  | 'inputMode'
  | 'type'
  | 'isDisabled'
  | 'isReadOnly'
  | 'onKeyDown'
  | 'maxLength'
  | 'slot'
> &
  InputGroupProps &
  Pick<InputProps, 'placeholder'> &
  FieldProps;

export const Input = forwardRef(function _Input(
  {
    label,
    isLabelVisuallyHidden,
    description,
    error,
    isRequired,
    labelInfo,
    maxWidth,
    startAdornment,
    endAdornment,
    isDisabled,
    placeholder,
    ...textFieldProps
  }: Props,
  ref: ForwardedRef<HTMLInputElement>,
) {
  const isInvalid = Boolean(error);
  return (
    <TextField {...textFieldProps} className={styles.field} isDisabled={isDisabled} isInvalid={isInvalid}>
      <Field
        label={label}
        isLabelVisuallyHidden={isLabelVisuallyHidden}
        description={description}
        error={error}
        isRequired={isRequired}
        labelInfo={labelInfo}
      >
        <InputGroup
          maxWidth={maxWidth}
          startAdornment={startAdornment}
          endAdornment={endAdornment}
          isDisabled={isDisabled}
          isInvalid={isInvalid}
          placeholder={placeholder}
          ref={ref}
        />
      </Field>
    </TextField>
  );
});
